module.exports = __webpack_public_path__ + "img/gatschkopf.4afd138a.jpg";